
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  Feat
} from "@dndModels";

export class CharacterFeat extends CharacterFeatureSource {
  source: Feat | null = null;
  level = 0;
  feat_source_id = "";
  feat_source_name = "";
  feat_source_type = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (obj.feat_id) {
        this.source_id = obj.feat_id;
        this.feat_source_id = obj.source_id;
      } else {
        this.feat_source_id = obj.feat_source_id ? obj.feat_source_id : "";
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_type = "Feat";
          fb.source_name = this.name;
          // fb.root_id = this.source_id;
          // fb.root_type = "Feat";
          // fb.root_name = this.name;
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          this.char_feature_bases.push(fb);
        });
      }
      this.level = obj.level ? obj.level : 0;
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      feat_source_id: this.feat_source_id
    };
  }

  clone(drop_ids = false): CharacterFeat {
    const clone = new CharacterFeat();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterFeat, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source;
    this.level = copyMe.level;
    this.feat_source_id = copyMe.feat_source_id;
    this.feat_source_name = copyMe.feat_source_name;
    this.feat_source_type = copyMe.feat_source_type;
  }
}